import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {Platform, MenuController, App} from 'ionic-angular';
import {ServiceProvider} from '../../providers/service/service';
import {Storage} from '@ionic/storage';
import {AlertController, Nav, ToastController, LoadingController, ModalController} from 'ionic-angular';
import {EnquirystatusPage} from "../enquirystatus/enquirystatus";
import {EnquiryresponsePage} from "../enquiryresponse/enquiryresponse";
import {ParentFeedbackPage} from "../parent-feedback/parent-feedback";
import {EnquiryRemarkPage} from "../enquiry-remark/enquiry-remark";
import {DomSanitizer} from '@angular/platform-browser';
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import { SocialSharing } from '@ionic-native/social-sharing';
import {AndroidPermissions} from "@ionic-native/android-permissions";
import {FileTransfer, FileTransferObject} from "@ionic-native/file-transfer";
import {File} from '@ionic-native/file';
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {DataCallLogPage} from "../data-call-log/data-call-log";
import {SubStatusHistoryPage} from "../sub-status-history/sub-status-history";


//@IonicPage()
@Component({
    selector: 'page-enquiry',
    templateUrl: 'enquiry.html',
})
export class EnquiryPage {
    FEnquiryId: any;
    SchoolData = {};
    TypeData = {};
    School = 'All';
    CommonTypeId = 'Enquiry';
    EnquiryData: any;
    EnquiryData1: any;
    FUserId: any;
    UserRights: any;
    DataSearch: any;
    FilterOption = 'Date';
    Date: any;
    DisplayDate = "";
    monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    SubStatus:any;
    SubStatusItem:any;

    SchoolName = 'WWGS/Contact';

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public service: ServiceProvider,
                public platform: Platform,
                menuCtrl: MenuController,
                public loadingCtrl: LoadingController,
                public toastCtrl: ToastController,
                public alertCtrl: AlertController,
                private modalCtrl: ModalController,
                public storage: Storage,
                private sanitizer: DomSanitizer,
                public _app: App,
                private contacts: Contacts,
                private socialSharing: SocialSharing,
                private androidPermissions:AndroidPermissions,
                private file: File,
                private transfer: FileTransfer,
                public iab: InAppBrowser) {
        this.platform.ready().then(() => {

            this.Date = new Date();
            this.DisplayDate = this.Date.getDate() + "-" + this.monthNames[this.Date.getMonth()] + "-" + this.Date.getFullYear();
            this.Date = this.Date.toISOString();

            this.SchoolData = {
                "All": 0,
                "GWW": 2,
                "GWE": 3,
                "GEIS": 1
            };

            this.TypeData = {
                "Admission": 2
            };

            Promise.all([this.storage.get('LoginData')]).then(values => {
                this.FUserId = values[0]['FUserId'];
                console.log(this.FUserId);
                this.get_user_rights(this.FUserId);
            });
        });
    }

    /*ionViewDidLoad() {
     this.platform.ready().then(() => {
     Promise.all([this.storage.get('LoginData')]).then(values => {
     this.FUserId = values[0]['FUserId'];
     console.log(this.FUserId);
     this.get_user_rights(this.FUserId);
     });
     });
     console.log('ionViewDidLoad EnquiryPage');
     }*/

    ionViewWillEnter() {
        this.platform.ready().then(() => {
            Promise.all([this.storage.get('LoginData')]).then(values => {
                this.FUserId = values[0]['FUserId'];
                console.log(this.FUserId);
                this.get_user_rights(this.FUserId);
            });
        });
        console.log('ionViewWillEnter PendingtaskPage');
    }


    sanitize(url: string) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }


    loadvalues(FSchoolId, FTypeId, FUserId, Date) {
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });
        loading.present();
        setTimeout(() => {
            loading.dismiss();
            loading = undefined;
        }, 5000);
        this.EnquiryData = [];
        console.log("FSchoolId", FSchoolId);
        console.log("FTypeId", FTypeId);
        this.service.httpcall('web_service/get_enquiry?FSchoolId=' + FSchoolId + '&FTypeId=' + FTypeId + '&FUserId=' + FUserId + '&Date=' + Date).subscribe(data => {
            if (loading)
                loading.dismiss();
            loading = undefined;
            console.log(data);
            this.EnquiryData1 = data;
            this.EnquiryData = this.EnquiryData1;

            this.DataSearch = "";
        })
    }

    add_filter(f) {
        console.log(f);
        if (f == 'All') {
            this.FilterOption = 'All';
            this.DisplayDate = "";
            this.loadvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
        } else {
            this.FilterOption = 'Date';
            var Date1 = new Date(this.Date);
            console.log(Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear());
            this.DisplayDate = Date1.getDate() + "-" + this.monthNames[Date1.getMonth()] + "-" + Date1.getFullYear();
            console.log("DisplayDate ", this.DisplayDate);
            this.loadvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
            //this.datePicker.open();
            /*if(this.Date==""){
             this.Date = new Date();
             this.Date = this.Date.toISOString();
             }else {
             this.Date = new Date(this.Date);
             this.Date = this.Date.toISOString();
             }*/


            console.log('Date call');
        }

    }


    Prev(date) {
        this.Date = new Date(date);
        this.Date.setDate(this.Date.getDate(date) - 1);
        this.Date = this.Date.toISOString();
        //in this case ion-datetime will call ionChange event
    }

    Next(date) {
        this.Date = new Date(date);
        this.Date.setDate(this.Date.getDate(date) + 1);
        this.Date = this.Date.toISOString();
        //in this case ion-datetime will call ionChange event
    }

    searchData(ev: any) {
        // Reset items back to all of the items
        this.EnquiryData = this.EnquiryData1;
        // set val to the value of the searchbar
        let val = ev.target.value;
        // if the value is an empty string don't filter the items
        if (val && val.trim() != '') {
            this.EnquiryData = this.EnquiryData.filter((item) => {
                return (item.Description.toLowerCase().indexOf(val.toLowerCase()) > -1);
            })
        }

    }

    get_user_rights(FUserId) {
        this.service.httpcall('web_service/get_users_rights?FUserId=' + FUserId).subscribe(data => {
            console.log(data['RightsData']);
            this.UserRights = data['RightsData'];
            if (this.UserRights != undefined) {
                console.log(this.School)
                this.loadvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
            }
        })
    }

    active_tab(tab) {
        console.log(tab);
        this.School = tab;
        this.CommonTypeId = 'Enquiry';
        this.loadvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
        //get types for that particular school only [{Enquiry:true,Admission:false}]
    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);

        this.loadvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
        setTimeout(() => {
            console.log('Async operation has ended');

            refresher.complete();
        }, 2000);
    }

    refresh() {
        console.log("refresh");
        this.loadvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
    }

    go_to_call_logs(item){
        let Call_logs_model = this.modalCtrl.create(DataCallLogPage,{data:item,Tab:3});
        // AppointmentModel.onDidDismiss(data => {
        //   console.log(data);
        // });
        Call_logs_model.present();
    }

    enquiry_call(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            cssClass: 'custom_alert',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Call',
                    handler: (data) => {

                        if(data != undefined){
                            console.log('Call clicked');
                            console.log(data);
                            console.log(JSON.parse(data));
                            let UserDetails = JSON.parse(data);
                            console.log(UserDetails.Name);
                            console.log(UserDetails.Contact);
                            console.log(enquirydata.Id);
                            if(UserDetails.Contact != "" && UserDetails.Contact != undefined){
                                this.service.httpcall('web_service/add_call_history?FEnquiryId=' + enquirydata.Id+'&UserFullName='+UserDetails.Name+'&Contact='+UserDetails.Contact).subscribe(response_data => {

                                    if (response_data['response'] == 'success') {
                                        // this.loadvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
                                        // window.location.href = 'tel:' + UserDetails.Contact;
                                        // console.log('tel:' + UserDetails.Contact);
                                        //window.open('tel:'+data);
                                        // this.FCallHistoryId=data.FCallHistoryId;
                                        let loading = this.loadingCtrl.create({
                                            content: 'Loading',
                                            enableBackdropDismiss:false
                                        });
                                        loading.present();


                                        var formdata=new FormData();
                                        formdata.append("FWebEnquiryId", enquirydata.FWebEnquiryId);
                                        formdata.append("AddedBy",this.FUserId);
                                        formdata.append("CallTo",UserDetails.Contact);
                                        formdata.append("CallType","2");
                                        formdata.append("FileName","text");
                                        // formdata.append("CallFor",this.CallFor);


                                        this.service.httppostFormcall('web_service/add_enquiry_call_logs', formdata).subscribe(resdata => {
                                            console.log(resdata);
                                            if (resdata['response'] == 'success') {
                                                var LogId=resdata['LogId'];
                                                if(loading)
                                                    loading.dismiss();
                                                loading = undefined;
                                                var link="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+UserDetails.Contact+"?/&apn=com.example.callrecording";
                                                const browser = this.iab.create(link,'_system',{location:'no'});
                                                window.location.href="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+UserDetails.Contact+"?/&apn=com.example.callrecording";
                                            } else {
                                                if(loading)
                                                    loading.dismiss();
                                                loading = undefined;
                                            }
                                        },(err)=>{
                                            if(loading)
                                                loading.dismiss();
                                            loading = undefined;
                                        });
                                    }else{
                                        let toast = this.toastCtrl.create({
                                            message: response_data['error_description'],
                                            duration: 5000,
                                            position: 'bottom'
                                        });
                                        toast.present();
                                    }

                                })
                            }

                        }else{
                            let toast = this.toastCtrl.create({
                                message: 'Please Select Contact',
                                duration: 5000,
                                position: 'bottom'
                            });
                            toast.present();
                            return false;
                        }


                    }
                },
                {
                    text: 'Add To Contact',
                    handler: (phone_num) => {
                        console.log(phone_num);
                        if(phone_num != undefined){
                            console.log(JSON.parse(phone_num));
                            let UserDetails = JSON.parse(phone_num);
                            console.log(UserDetails.Name);
                            console.log(UserDetails.Contact);

                            let contact: Contact = this.contacts.create();
                            //contact.name = new ContactName(null, FirstName, LastName);
                            contact.name = new ContactName(null, UserDetails.Name, null);
                            contact.phoneNumbers = [new ContactField('mobile', UserDetails.Contact)];
                            contact.save().then(
                                () =>{
                                    console.log('Contact saved!', contact);
                                    let toast = this.toastCtrl.create({
                                        message: 'Contact saved!',
                                        duration: 5000,
                                        position: 'middle'
                                    });
                                    toast.present();
                                    return true;
                                } ,
                                (error: any) => {
                                    console.error('Error saving contact.', error);
                                    let toast = this.toastCtrl.create({
                                        message: 'Error saving contact.',
                                        duration: 5000,
                                        position: 'middle'
                                    });
                                    toast.present();
                                    return false;
                                }
                            );
                        }else{
                            let toast = this.toastCtrl.create({
                                message: 'Please Select Contact',
                                duration: 5000,
                                position: 'bottom'
                            });
                            toast.present();
                            return false;
                        }


                    }
                }
            ]
        });

        let FatherDetails = {Name:enquirydata.FatherName,Contact:enquirydata.Contact};
        let MotherDetails = {Name:enquirydata.MotherName,Contact:enquirydata.MotherContact};
        myAlert.addInput({
            type: 'radio',
            label: 'Father: ' + enquirydata.FatherName + ' (' + enquirydata.Contact + ')',
            value: JSON.stringify(FatherDetails)
        })
        myAlert.addInput({
            type: 'radio',
            label: 'Mother: ' + enquirydata.MotherName + ' (' + enquirydata.MotherContact + ')',
            value: JSON.stringify(MotherDetails)
        })
        myAlert.present();


    }

    whatsapp_call(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Message',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);

                        window.location.href = 'whatsapp://send?phone=+91' + data;


                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: 'Father: ' + enquirydata.FatherName + ' (' + enquirydata.Contact + ')',
            value: enquirydata.Contact
        })
        myAlert.addInput({
            type: 'radio',
            label: 'Mother: ' + enquirydata.MotherName + ' (' + enquirydata.MotherContact + ')',
            value: enquirydata.MotherContact
        })
        myAlert.present();


    }

    message_call(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Message',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);

                        let loading = this.loadingCtrl.create({
                            content: ''
                        });
                        loading.present();

                        setTimeout(() => {
                            loading.dismiss();
                        }, 10000);

                        let data1 = {
                            Id: enquirydata.Id,
                            FUserId:this.FUserId};
                        console.log('data1', data1);

                        this.service.httppostcall('web_service/get_enquiry_msg', data1).subscribe((result_data: any) => {
                            loading.dismiss();
                            if (result_data['status'] == 'success') {

                                window.location.href = 'whatsapp://send?text=' + result_data['msg'] + '&phone=+91' + data + '&abid=+91' + data + '&url=' + result_data['msg'];

                            } else {
                                let toast = this.toastCtrl.create({
                                    message: 'something went wrong',
                                    duration: 5000,
                                    position: 'middle'
                                });
                                toast.present();
                            }
                        });


                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: 'Father: ' + enquirydata.FatherName + ' (' + enquirydata.Contact + ')',
            value: enquirydata.Contact
        })
        myAlert.addInput({
            type: 'radio',
            label: 'Mother: ' + enquirydata.MotherName + ' (' + enquirydata.MotherContact + ')',
            value: enquirydata.MotherContact
        })
        myAlert.present();
    }

    status_click(item, eqId, FCallHistoryId, date) {
        console.log("FCallHistoryId", item.FCallHistoryId, item);
        console.log("date", item.date, item);
        let Record = this.modalCtrl.create(EnquirystatusPage, {
            "parentPage": this,
            eqId: item.Id,
            FCallHistoryId: item.FCallHistoryId,
            date: item.date
        });
        Record.present();
    }

    response_click(FEnquiryId) {
        let Record = this.modalCtrl.create(EnquiryresponsePage, {FEResponseId: FEnquiryId});
        Record.present();
    }

    goto_parent_feedback(enq) {
        let parent_feedback = this.modalCtrl.create(ParentFeedbackPage,{"parentPage": this, "FEnquiryId": enq.Id});
        parent_feedback.present();
        //this.navCtrl.push(ParentFeedbackPage, {"parentPage": this, "FEnquiryId": enq.Id})
    }

    goto_enquiry_remark(enq){
        let enquiry_remark = this.modalCtrl.create(EnquiryRemarkPage,{"parentPage": this, "FEnquiryId": enq.Id});
        enquiry_remark.present();
    }


    msg_Group(item){

        this.socialSharing.shareViaWhatsApp(item.Description, null, null);

    }

    shareContact(item){
        this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(
            result =>{
                console.log('Has permission?',result.hasPermission);

                if (result.hasPermission) {
                    this.file_download(item);
                } else {
                    this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE, this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE]);
                    this.file_download(item);
                }
            },
            err => {
                console.log(err);
                this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE, this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE]);
                this.file_download(item);
            }
        );
    }

    file_download = function (img) {

        console.log(img);
        var imageName = img.SchoolOfficeContact;
        // var imageName = 'SchoolOfficeNumber.vcf';
        var parts = imageName.split('.');
        console.log(parts);
        var title = parts[0];
        var ext = parts[1];

        var path = this.service.baseUrl+img.SchoolOfficeContactPath+img.SchoolOfficeContact;
        // var path = this.service.baseUrl+'/application/Contacts/SchoolOfficeNumber.vcf';

        var BasePath = (this.file.externalRootDirectory || this.file.documentsDirectory);


        this.file.checkFile(BasePath, this.SchoolName + "/" + title + "." + ext).then(result => {
            // Success!
            console.log('File Success!');
            var localPath = BasePath + this.SchoolName + "/" + title + "." + ext;
            console.log("localPath",localPath);
            //this.photoViewer.show(localPath, this.SubjectName, {share: false});
            //this.socialSharing.share("test", null, localPath, null);
            this.socialSharing.shareViaWhatsApp(null, localPath, null);
            //this.socialSharing.shareViaWhatsAppToReceiver('+918087226223', null, localPath, null);
        }, err => {
            // An error occured. Show a message to the user
            console.log('File Not Exist');
            console.log(err);

            const fileTransfer: FileTransferObject = this.transfer.create();

            const url = path;
            console.log(url);
            var device_path = (this.file.externalRootDirectory || this.file.documentsDirectory);
            var targetPath = device_path + this.SchoolName +"/" + title + "." + ext;
            console.log("targetPath",targetPath);
            fileTransfer.download(url, targetPath).then((entry) => {
                console.log('download complete: ' + entry.toURL());
                var contentType = '';
                console.log("ext",ext);
                this.socialSharing.shareViaWhatsApp(null, entry.toURL(), null);
                /*if (ext == 'pdf' || ext == 'PDF')
                 contentType='application/pdf';
                 else
                 contentType='image/'+ext;

                 console.log(contentType);
                 this.fileOpener.open(targetPath, contentType)
                 .then(() => console.log('File is opened'))
                 .catch(e => console.log('Error opening file', e));*/
                //this.photoViewer.show(targetPath, this.SubjectName, {share: false});
            }, (error) => {
                console.log("error",error);
            });
        });



    }

    add_SubStatus(item){


        this.SubStatus=null;
        this.SubStatusItem=null;
        this.service.httpcall('web_service/get_master_enquiry_substatus?params[FStatusId]='+item.StatusId).subscribe(data => {
            console.log("getReasons",data);
            if(data['response']=="success"){
                this.SubStatus=data['data'];
                console.log(this.SubStatus);
                let myAlert = this.alertCtrl.create({
                    title: 'Set SubStatus',
                    buttons: [
                        {
                            text: 'Cancel',
                            role: 'cancel',
                            handler: () => {
                                console.log('Cancel clicked');
                            }
                        },
                        {
                            text: 'Confirm',
                            handler: (data) => {
                                console.log('clicked');
                                console.log(data);

                                this.service.httpcall('web_service/add_subStatus_On_webEnquiryId?FStatusId=' + item.StatusId+'&FWebEnquiryId=' + item.FWebEnquiryId+'&FUserId=' + this.FUserId+'&FSubStatusId=' + data).subscribe(data => {
                                    console.log(data);
                                    if(data['response']=="success"){
                                        this.presentToast(data['success_message']);
                                        this.loadvalues(this.SchoolData[this.School], this.TypeData[this.CommonTypeId], this.FUserId, this.DisplayDate);
                                    }else{
                                        this.presentToast(data['error_description']);
                                    }

                                },(error2 => {
                                    this.presentToast("Timeout!");
                                }))

                            }
                        }
                    ]
                });
                for(var i = 0; i < this.SubStatus.length; i++) {
                    this.SubStatusItem=this.SubStatus[i];
                    var edata=this.SubStatusItem.SubStatusName;
                    console.log(edata);
                    myAlert.addInput({
                        type:'radio',
                        label: edata,
                        value:  this.SubStatusItem.Id
                    })
                }

                myAlert.present();
            }else{
                this.presentToast(data['error_description']);

            }

        },(error2 => {
            this.presentToast("Timeout!");

        }))


    }

    go_to_SubStatus_hist(item){
        let SubStatusHistory = this.modalCtrl.create(SubStatusHistoryPage,{FWebEnquiryId:item.FWebEnquiryId});
        SubStatusHistory.onDidDismiss(data => {
            console.log(data);
        });
        SubStatusHistory.present();
    }

    presentToast(msg){
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/enquiry/enquiry.ts